<template>
  <div class="headerActions flex-column d-flex">
    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>
    <div class="d-flex align-items-stretch h-100">
      <div
        v-if="show.checkItems"
        class="headerActions__item headerActions__selected selectedCheck d-flex align-items-center justify-content-start pl-3"
      >
        <template v-if="multiSelect">
          <CInputCheckbox
            @click.stop
            class="text-center checkboxTable"
            :checked="itemsListSelected"
            @update:checked="(a, b) => checkAll(a, b)"
            custom
          />
          <CDropdown color="transparent pt-0" toggler-text="" class="m-1 p-0" addTogglerClasses="p-0 btn-dropdown">
            <template slot="toggler">
              <div class="text-gray-600 py-2">
                <CIcon name="arrow" class="text-gray-600 pt-1" size="custom-size" :height="18" viewBox="0 0 32 32" />
              </div>
            </template>
            <CDropdownItem class="text-decoration-none" @click.stop="checkAll(true)">Todos</CDropdownItem>
            <CDropdownItem class="text-decoration-none" @click.stop="checkAll(false)">Nenhum</CDropdownItem>
          </CDropdown>
        </template>

        <template v-if="aproveRefuse">
          <AproveRefuseComponent @aproved="$emit('aproved')" @refused="$emit('refused')" />
        </template>

        <div class="d-flex align-items-center justify-content-center" v-if="itemsListSelected">
          <CButton
            v-if="show.delete"
            class="headerActions__button"
            v-c-tooltip="{ content: 'Delete', placement: 'top' }"
            @click.stop="statePopUpSelectDelete = !statePopUpSelectDelete"
          >
            <CIcon
              name="trash"
              class="text-gray-600"
              size="custom-size"
              :height="20"
              viewBox="0 0 32 32"
              :class="{ 'text-gray-700': statePopUpSelectDelete == true }"
            />
          </CButton>

          <transition name="fade" v-if="statePopUpSelectDelete">
            <div class="dataTable__popUp popUp" @click.stop.stop>
              <div class="popUp__body shadow-sm">
                <ConfirmationDelete @confirm="confirmDeleteItemSelected" :description="confirmationDeleteDescription" @cancel="closePopUp()" />
              </div>
            </div>
          </transition>

          <AssociateUser v-if="show.associate" @response-message="responseMessage" />
          <SenderRequest
            :loading="loadingSenderRequest"
            v-if="showApproveRefuse"
            @response-message="responseMessage"
            @sendApproveOrReprove="sendApproveOrReprove"
          />
        </div>

        <!-- <div class="d-flex align-items-center justify-content-center"  v-if="activeRegister">
          <CButton
            class="headerActions__button "
            v-c-tooltip="{ content: 'Active', placement: 'top' }"
            @click.stop="statePopUpSelectActive = !statePopUpSelectActive"
          >
            <CIcon
              name="padlock"
              class="text-gray-600"
              size="custom-size"
              :height="20"
              viewBox="0 0 32 32"
              :class="{ 'text-gray-700': statePopUpSelectActive == true }"
            />
          </CButton>

          <transition name="fade" v-if="statePopUpSelectActive">
            <div class="dataTable__popUp popUp" @click.stop.stop>
              <div class="popUp__body shadow-sm">
                <ConfirmationDelete
                  :title="popUpActiveteTitle"
                  :description="popUpActivateDescription"
                  @confirm="confirmActiveItemSelected"
                  @cancel="closePopUp()"
                />
              </div>
            </div>
          </transition>
        </div> -->
        <div>
          <template v-if="activeRegister || inactiveRegister">
            <CDropdown color="transparent" class="m-2 text-gray-500" addTogglerClasses="p-0 ">
              <template slot="toggler">
                <div class="text-gray-600 py-2 dropdown__header d-flex align-items-center" :class="{ 'text-gray-700': statePopUpManage == true }">
                  <CIcon name="padlock" size="custom-size" :height="20" viewBox="0 0 32 32" />
                </div>
              </template>
              <CDropdownItem class="text-decoration-none" :disabled="!activeRegister" @click.stop="confirmActiveItemSelected">{{
                $t('general.components.table.headerActions.dropdown.active-register')
              }}</CDropdownItem>
              <CDropdownItem class="text-decoration-none" :disabled="!inactiveRegister" @click.stop="confirmInactiveItemSelected">{{
                $t('general.components.table.headerActions.dropdown.inactive-register')
              }}</CDropdownItem>
            </CDropdown>
          </template>
        </div>
      </div>

      <div class="headerActions__item headerActions__manager d-flex align-items-center justify-content-end ml-auto" style="min-width: 250px">
        <template v-if="show.manage">
          <CDropdown
            color="transparent"
            :toggler-text="$t('general.components.table.headerActions.dropdown.manage-contacts')"
            class="m-2 text-gray-500"
            addTogglerClasses="p-0 "
          >
            <template slot="toggler">
              <div class="text-gray-600 py-2 dropdown__header d-flex align-items-center" :class="{ 'text-gray-700': statePopUpManage == true }">
                <CIcon name="manage" size="custom-size" :height="21" viewBox="0 0 32 32" />
                <span class="mx-2">{{ $t('general.components.table.headerActions.dropdown.manage-contacts') }}</span>
                <CIcon name="arrow" size="custom-size" :height="15" viewBox="0 0 32 32" />
              </div>
            </template>
            <CDropdownItem class="text-decoration-none" @click.stop="goToPage('import-history')">{{
              $t('general.components.table.headerActions.dropdown.import-historic')
            }}</CDropdownItem>
            <CDropdownItem class="text-decoration-none" @click.stop="goToPage('custom-fields')">{{
              $t('general.components.table.headerActions.dropdown.custom-fields')
            }}</CDropdownItem>
            <CDropdownItem v-show="Boolean(totalRecords) && show.export" class="text-decoration-none" @click.stop="openPopUpComponent('export')">{{
              $t('general.components.table.headerActions.dropdown.export')
            }}</CDropdownItem>
            <CDropdownItem
              v-show="Boolean(totalRecords) && show.deleteAll"
              class="text-decoration-none"
              @click.stop="openPopUpComponent('deleteAll')"
              >{{ $t('general.components.table.headerActions.dropdown.delete-all') }}</CDropdownItem
            >
          </CDropdown>

          <transition name="fade" v-if="statePopUpManage">
            <div class="dataTable__popUp popUp" @click.stop.stop>
              <div class="popUp__body shadow-sm">
                <TripleConfirmationDelete
                  v-show="popUpName == 'deleteAll'"
                  :confirmationText="tripleConfirmationText"
                  @confirm="emitDelete"
                  @cancel="closePopUp"
                />
                <ChooseExport v-show="popUpName == 'export'" :totalRecords="totalRecords" @confirm="exportRecods($event)" @cancel="closePopUp" />
              </div>
            </div>
          </transition>
        </template>
        <template v-if="show.manageSegment">
          <CDropdown color="transparent" toggler-text="Manage contacts" class="m-2 text-gray-500" addTogglerClasses="p-0 ">
            <template slot="toggler">
              <div class="text-gray-600 py-2 dropdown__header d-flex align-items-center" :class="{ 'text-gray-700': statePopUpManage == true }">
                <CIcon name="manage" size="custom-size" :height="21" viewBox="0 0 32 32" />
                <span class="mx-2">{{ $t('general.components.table.headerActions.dropdown.manage-segment') }}</span>
                <CIcon name="arrow" size="custom-size" :height="15" viewBox="0 0 32 32" />
              </div>
            </template>
            <CDropdownItem class="text-decoration-none" @click.stop.stop="openPopUpComponent('export')">{{
              $t('general.components.table.headerActions.dropdown.export-segment')
            }}</CDropdownItem>
            <CDropdownItem class="text-decoration-none" @click.stop="editSegment()">{{
              $t('general.components.table.headerActions.dropdown.edit-segment')
            }}</CDropdownItem>
            <CDropdownItem class="text-decoration-none" @click.stop.stop="openPopUpComponent('deleteAll')">{{
              $t('general.components.table.headerActions.dropdown.delete-segment')
            }}</CDropdownItem>
          </CDropdown>

          <transition name="fade" v-if="statePopUpManage">
            <div class="dataTable__popUp popUp" @click.stop.stop>
              <div class="popUp__body shadow-sm">
                <TripleConfirmationDelete v-show="popUpName == 'deleteAll'" @confirm="emitDelete" @cancel="closePopUp" />
                <ChooseExport v-show="popUpName == 'export'" :totalRecords="totalRecords" @confirm="exportRecods($event)" @cancel="closePopUp" />
              </div>
            </div>
          </transition>
        </template>
        <template v-if="show.filterBy">
          <CDropdown color="transparent" toggler-text="Manage contacts" class="m-2 text-gray-500" addTogglerClasses="p-0 ">
            <template slot="toggler">
              <div class="text-gray-600 py-2 dropdown__header d-flex align-items-center" :class="{ 'text-gray-700': statePopUpManage == true }">
                <span class="mx-2 text-uppercase">{{ $t('general.components.table.headerActions.dropdown.filter-by') }}</span>
                <CIcon name="arrow" size="custom-size" :height="15" viewBox="0 0 32 32" />
              </div>
            </template>
            <CDropdownItem
              v-for="(item, index) in filterByData"
              :key="index"
              class="text-decoration-none text-capitalize"
              :class="{ active: item.label == filterBySelected }"
              @click.stop="chooseFilterBy(item)"
              >{{ item.label }}</CDropdownItem
            >
            <CDropdownItem class="text-decoration-none text-capitalize" @click.stop="chooseFilterBy('all')">{{
              $t('general.components.table.headerActions.dropdown.all')
            }}</CDropdownItem>
          </CDropdown>
        </template>
        <div v-if="show.orderByDate" @click="sortByDate()" class="selectedCheck">
          <span v-if="show.orderByDate.type == 'edited'" class="textDateCreated">{{
            $t('general.components.table.headerActions.dropdown.data-edited')
          }}</span>
          <span v-else class="textDateCreated">{{ $t('general.components.table.headerActions.dropdown.data-created') }}</span>
          <i v-if="orderByDate" class="fa fa-long-arrow-down iconDateCreated" aria-hidden="true"></i>
          <i v-else class="fa fa-long-arrow-up iconDateCreated" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TripleConfirmationDelete from '@/components/TripleConfirmationDelete'
import ConfirmationDelete from '@/components/ConfirmationDelete'
import ChooseExport from '@/components/ChooseExport'
import AssociateUser from '@/components/AssociateUser'
import SenderRequest from '@/components/SenderRequest'
import AproveRefuseComponent from '@/components/AproveRefuse'
import MenssageAlert from '@/components/MenssageAlert'

export default {
  name: 'HeaderActions',
  components: {
    TripleConfirmationDelete,
    ConfirmationDelete,
    MenssageAlert,
    ChooseExport,
    AssociateUser,
    SenderRequest,
    AproveRefuseComponent,
  },
  props: {
    confirmationDeleteDescription: {
      type: String,
    },
    tripleConfirmationText: {
      type: String,
    },
    loadingSenderRequest: {
      type: Boolean,
      default: () => false,
    },
    showApproveRefuse: {
      type: Boolean,
      default: () => false,
    },
    show: {
      type: Object,
      default: function () {
        return {
          delete: true,
          deleteAll: true,
          checkItems: true,
          associate: false,
          approveRefuse: false,
          manage: false,
          export: true,
          orderByDate: {
            type: Object,
            default: () => {},
          },
          manageSegment: false,
          filterBy: false,
        }
      },
    },
    aproveRefuse: {
      type: Boolean,
      default: false,
    },
    // TODO Pensar em um nome mais adequado para esta propriedade
    multiSelect: {
      type: Boolean,
      default: true,
    },
    typeName: {
      type: String,
      default: 'audiance',
    },
    filterByData: {
      type: Array,
    },
    itemsListSelected: {
      type: Boolean,
      default: false,
    },
    totalRecords: {
      type: Number,
      default: 1000000,
    },

    activeRegister: {
      type: Boolean,
      default: false,
    },

    inactiveRegister: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popUpName: '',
      statePopUpManage: false,
      statePopUpSelectDelete: false,
      filterBySelected: null,
      messages: [],
      statePopUpSelectActive: false,
      orderByDate: true,
    }
  },

  mounted() {
    this.$root.$on('update-close-popup', () => {
      this.closePopUp()
    })
  },

  methods: {
    goToPage(nameRoute) {
      this.$router.push({ name: nameRoute })
    },

    checkAll(state) {
      this.$emit('checkAll', state)
    },

    editSegment(state) {
      this.$emit('editSegment', state)
    },

    confirmDeleteItemSelected() {
      this.$emit('confirm')
      this.statePopUpSelectDelete = false
    },

    confirmActiveItemSelected() {
      this.$emit('confirm-active')
      this.statePopUpSelectActive = false
    },

    confirmInactiveItemSelected() {
      this.$emit('confirm-inactive')
      this.statePopUpSelectActive = false
    },

    openPopUpComponent(popUpName) {
      this.popUpName = popUpName
      this.statePopUpManage = true
    },

    closePopUp() {
      this.statePopUpSelectDelete = false
      this.statePopUpManage = false
      this.typeFileExport = null
      this.statePopUpSelectActive = false
    },

    emitDelete() {
      this.$emit('deleteAll')
      this.closePopUp()
    },

    exportRecods(events) {
      this.$emit('exportRecods', events)
      this.closePopUp()
    },

    sortByDate() {
      this.orderByDate = !this.orderByDate
      this.$emit('sortByDate', !this.orderByDate)
    },

    chooseFilterBy(item) {
      this.filterBySelected = item.label
      this.$emit('filterBy', item)
    },

    sendApproveOrReprove(obj) {
      this.$emit('approveOrReprove', obj)
    },

    responseMessage(obj) {
      this.messages = []
      this.messages.push(obj)
    },
  },
}
</script>

<style lang="scss">
.headerActions {
  height: 64px;
  position: relative;

  &__selected {
    max-width: 95px;
    width: 100%;

    .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
      content: '-';
      color: var(--white);
      font-size: 30px;
      line-height: 20px;
      background-image: none;
    }

    .dropdown-toggle::after {
      border-top: 0.3em solid var(--blue-dark);
    }
  }

  &__button {
    padding: 8px;
    min-width: 42px;

    &:hover {
      .icon {
        color: var(--gray-700) !important;
      }
    }
  }

  .bs-tooltip-old-auto[x-placement^='bottom'] .arrow:before {
    display: none;
    top: -20px;
  }

  .bs-tooltip-old-auto[x-placement^='top'] .arrow:before,
  .bs-tooltip-old-top .arrow:before {
    top: 0;
    border-width: 0.4rem 0.4rem 0;
    border-top-color: #ffffff;
  }

  .tooltip-old-inner {
    border-radius: 2px;
    box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.12);
    background-color: #ffffff;
    color: #7f889a;
  }
}

.selectedCheck {
  cursor: pointer;
}

.textDateCreated {
  color: #a1a8b3;
  font-size: 14px;
}

.iconDateCreated {
  color: #a1a8b3;
  font-size: 15px;
  margin-left: 7px;
  margin-right: 8px;
  cursor: pointer;
}

.disable-item {
  &:hover {
    cursor: not-allowed !important;
  }
}
</style>
